/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterStatContentAddPost } from '../fn/stat-content/api-master-stat-content-add-post';
import { ApiMasterStatContentAddPost$Params } from '../fn/stat-content/api-master-stat-content-add-post';
import { apiMasterStatContentDeleteGet } from '../fn/stat-content/api-master-stat-content-delete-get';
import { ApiMasterStatContentDeleteGet$Params } from '../fn/stat-content/api-master-stat-content-delete-get';
import { apiMasterStatContentEditPost } from '../fn/stat-content/api-master-stat-content-edit-post';
import { ApiMasterStatContentEditPost$Params } from '../fn/stat-content/api-master-stat-content-edit-post';
import { apiMasterStatContentGetActiveGet } from '../fn/stat-content/api-master-stat-content-get-active-get';
import { ApiMasterStatContentGetActiveGet$Params } from '../fn/stat-content/api-master-stat-content-get-active-get';
import { apiMasterStatContentGetAllGet } from '../fn/stat-content/api-master-stat-content-get-all-get';
import { ApiMasterStatContentGetAllGet$Params } from '../fn/stat-content/api-master-stat-content-get-all-get';
import { apiMasterStatContentGetByCriteriaPost } from '../fn/stat-content/api-master-stat-content-get-by-criteria-post';
import { ApiMasterStatContentGetByCriteriaPost$Params } from '../fn/stat-content/api-master-stat-content-get-by-criteria-post';
import { apiMasterStatContentGetByIdGet } from '../fn/stat-content/api-master-stat-content-get-by-id-get';
import { ApiMasterStatContentGetByIdGet$Params } from '../fn/stat-content/api-master-stat-content-get-by-id-get';
import { StatContent } from '../models/stat-content';
import { StatContentApiRespModel } from '../models/stat-content-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class StatContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterStatContentAddPost()` */
  static readonly ApiMasterStatContentAddPostPath = '/api/Master/StatContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterStatContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterStatContentAddPost$Response(params?: ApiMasterStatContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StatContentApiRespModel>> {
    return apiMasterStatContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterStatContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterStatContentAddPost(params?: ApiMasterStatContentAddPost$Params, context?: HttpContext): Observable<StatContentApiRespModel> {
    return this.apiMasterStatContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatContentApiRespModel>): StatContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterStatContentEditPost()` */
  static readonly ApiMasterStatContentEditPostPath = '/api/Master/StatContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterStatContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterStatContentEditPost$Response(params?: ApiMasterStatContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StatContentApiRespModel>> {
    return apiMasterStatContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterStatContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterStatContentEditPost(params?: ApiMasterStatContentEditPost$Params, context?: HttpContext): Observable<StatContentApiRespModel> {
    return this.apiMasterStatContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatContentApiRespModel>): StatContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterStatContentDeleteGet()` */
  static readonly ApiMasterStatContentDeleteGetPath = '/api/Master/StatContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterStatContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterStatContentDeleteGet$Response(params?: ApiMasterStatContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterStatContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterStatContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterStatContentDeleteGet(params?: ApiMasterStatContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterStatContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterStatContentGetByIdGet()` */
  static readonly ApiMasterStatContentGetByIdGetPath = '/api/Master/StatContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterStatContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterStatContentGetByIdGet$Response(params?: ApiMasterStatContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StatContent>> {
    return apiMasterStatContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterStatContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterStatContentGetByIdGet(params?: ApiMasterStatContentGetByIdGet$Params, context?: HttpContext): Observable<StatContent> {
    return this.apiMasterStatContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatContent>): StatContent => r.body)
    );
  }

  /** Path part for operation `apiMasterStatContentGetAllGet()` */
  static readonly ApiMasterStatContentGetAllGetPath = '/api/Master/StatContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterStatContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterStatContentGetAllGet$Response(params?: ApiMasterStatContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StatContent>>> {
    return apiMasterStatContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterStatContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterStatContentGetAllGet(params?: ApiMasterStatContentGetAllGet$Params, context?: HttpContext): Observable<Array<StatContent>> {
    return this.apiMasterStatContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<StatContent>>): Array<StatContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterStatContentGetActiveGet()` */
  static readonly ApiMasterStatContentGetActiveGetPath = '/api/Master/StatContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterStatContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterStatContentGetActiveGet$Response(params?: ApiMasterStatContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StatContent>>> {
    return apiMasterStatContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterStatContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterStatContentGetActiveGet(params?: ApiMasterStatContentGetActiveGet$Params, context?: HttpContext): Observable<Array<StatContent>> {
    return this.apiMasterStatContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<StatContent>>): Array<StatContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterStatContentGetByCriteriaPost()` */
  static readonly ApiMasterStatContentGetByCriteriaPostPath = '/api/Master/StatContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterStatContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterStatContentGetByCriteriaPost$Response(params?: ApiMasterStatContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StatContent>>> {
    return apiMasterStatContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterStatContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterStatContentGetByCriteriaPost(params?: ApiMasterStatContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<StatContent>> {
    return this.apiMasterStatContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<StatContent>>): Array<StatContent> => r.body)
    );
  }

}
